import React, { useEffect, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import AddClientCompanyType from './AddClientCompanyType';
import DeleteClientCompanyType from './DeleteClientCompanyType';
import ViewClientCompanyType from './ViewClientCompanyType';
import EditClientCompanyType from './EditClientCompanyType';
import ClientCompanyTypeModel from './models/ClientCompanyTypeModel';
import { logAuditEvent } from '../../utils/auditLogger';

function ClientCompanyTypeModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName = 'Client Company Type'}) {
    const [childData, setChildData] = useState(new ClientCompanyTypeModel() || []);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        if (show && selectedRow) {
          setChildData({ ...selectedRow }); // create a new object to break reference
        } else if (!show) {
          setChildData(new ClientCompanyTypeModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = (data) => {
        setChildData(data);
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const actionDescriptor = (UserAction === 'Delete') ? 'Delete Confirm' : 'Save';
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${actionDescriptor}`, `${actionDescriptor} clicked`);
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleCancel = (label) => {
        logAuditEvent(moduleName, `${UserAction || 'Action'} ${label}`, `${label} clicked`);
        onClose();
    };

    const handleLoad = (data) => {
        setChildData(data); // Send the form data back to the parent component
    };
    if(UserAction === "Add"){
        modalAction = <AddClientCompanyType  onLoad= {handleLoad} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={() => handleCancel('Cancel')}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = <EditClientCompanyType ClientCompanyTypeData={childData} onSubmit= {onSubmit} sendDataToParent={handleDataFromChild}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={() => handleCancel('Cancel')}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewClientCompanyType ClientCompanyTypeData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={() => handleCancel('Close')}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteClientCompanyType ClientCompanyTypeData={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={() => handleCancel('Delete Cancel')}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    }
  return (
    UserAction !== "Delete" ?
            <Modal
                show={show}
                backdrop="static"
            >
                <ModalHeader className="modal-header border-0 custom-modal-header" >
                    <ModalTitle >{userAction} Client Company Type</ModalTitle>
                    <button type="button" className="close" aria-label="Close" onClick={() => handleCancel('Close')}>
                        <span aria-hidden="true">×</span>
                    </button>
                </ModalHeader>
                <ModalBody> 
                    {modalAction}
                </ModalBody>
                <ModalFooter className="">
                    {showButtons}
                </ModalFooter>
            </Modal> 
        :   <Modal
            show={show}
            onHide={() => handleCancel('Close')}
                backdrop="static"            >
           
                <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                    <ModalTitle>
                        <div className="custom-alert-icon">
                            <Icons.AlertOctagon className="flex-shrink-0"/>
                        </div>
                        <div > {userAction} Client Company Type</div>
                    </ModalTitle>
                </ModalHeader>
                
                <ModalBody>
                    {modalAction}
                </ModalBody>
                <ModalFooter className="modalfooter-width">
                    {showButtons}
                </ModalFooter>
            </Modal>  
  )
}

export default ClientCompanyTypeModal